// extracted by mini-css-extract-plugin
export default {"container":"SDG9P"};